export default __webpack_public_path__ + "static/media/FLSmile.85bca234.svg";